(function () {
  var GRID_SELECTOR = 'ul#product-grid, ul.product-grid';

  function sortGrid(grid) {
    if (!grid) return;
    var soldOut = grid.querySelectorAll(':scope > [data-sold-out]');
    if (!soldOut.length) return;
    var frag = document.createDocumentFragment();
    soldOut.forEach(function (li) { frag.appendChild(li); });
    grid.appendChild(frag);
  }

  function sortAll() {
    document.querySelectorAll(GRID_SELECTOR).forEach(sortGrid);
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    sortAll();

    // Shopify's facets/pagination replaces the grid's innerHTML. Re-sort
    // whenever the children change, debounced so a single batch update
    // only triggers one sort.
    var pending = null;
    var observer = new MutationObserver(function () {
      if (pending) cancelAnimationFrame(pending);
      pending = requestAnimationFrame(sortAll);
    });

    document.querySelectorAll(GRID_SELECTOR).forEach(function (grid) {
      observer.observe(grid, { childList: true });
    });

    // Also catch grids that get added after load (e.g. infinite scroll apps).
    var rootObserver = new MutationObserver(function () {
      document.querySelectorAll(GRID_SELECTOR).forEach(function (grid) {
        if (grid.__soldOutWatched) return;
        grid.__soldOutWatched = true;
        observer.observe(grid, { childList: true });
        sortGrid(grid);
      });
    });
    rootObserver.observe(document.body, { childList: true, subtree: true });
  });
})();
